<template lang="pug">
  .my-team
    WtTitle.my-team-title(card-title).mb-4 {{teamTitle}}
    WtRouterLink.is-size-7.view-details-link(
      to="Team"
      :params="{ teamId: team.teamNameURL }"
    ) View Details
    .my-team-body
      WtRouterLink.is-flex.is-align-items-center.has-text-grey-dark(
        to="Team"
        :params="{ teamId: team.teamNameURL }"
        type="list"
      )
        WtEntityAvatar.mr-3(:image="team.logo" size-class="is-64x64" is-rounded)
        .block
          WtTitle.mb-0(size="h4") {{ team.name }}
          span.is-size-7.has-text-grey {{ countMembersText }}
      WtTile(:isLoading="!teamAggregateDataLoaded" vertical).mt-5
        span.is-size-6.has-text-grey Steps & Activities
        .is-flex.is-justify-content-space-around.is-flex-wrap-wrap.has-text-centered.mt-2
          .p-1
            p.has-text-black.is-size-5 {{ todayStepsAndActivities }}
            p.has-text-grey.is-size-7 Today
          .p-1
            p.has-text-black.is-size-5 {{ averageStepsAndActivities }}
            p.has-text-grey.is-size-7 Average
          .p-1
            p.has-text-black.is-size-5 {{ totalStepsAndActivities }}
            p.has-text-grey.is-size-7 Total
</template>

<script>
import { mapActions } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtEntityAvatar from "@@/WtEntityAvatar/WtEntityAvatar";
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";

export default {
  name: "MyTeam",

  components: { WtTitle, WtTile, WtRouterLink, WtEntityAvatar },

  mixins: [dateUtilityMixin],

  props: {
    team: {
      type: Object,
      required: true
    },
    teamTitle: {
      type: String,
      default: "My Team"
    }
  },

  data() {
    return {
      teamAggregateData: [],
      teamAggregateDataLoaded: false
    };
  },

  computed: {
    countMembersText() {
      return this.team.numMembers === 1
        ? "1 Member"
        : `${this.team.numMembers} Members`;
    },

    todayStepsAndActivities() {
      const todayStepAndActivitiesSum =
        this._.get(this.teamAggregateData, "todaySteps", 0) +
        this._.get(this.teamAggregateData, "todayActivities", 0);
      if (todayStepAndActivitiesSum) {
        return todayStepAndActivitiesSum.toLocaleString();
      } else {
        return "-";
      }
    },

    averageStepsAndActivities() {
      const averageStepAndActivitiesSum =
        this._.get(this.teamAggregateData, "averageSteps", 0) +
        this._.get(this.teamAggregateData, "averageActivities", 0);
      if (averageStepAndActivitiesSum) {
        return averageStepAndActivitiesSum.toLocaleString();
      } else {
        return "-";
      }
    },

    totalStepsAndActivities() {
      const totalStepAndActivitiesSum =
        this._.get(this.teamAggregateData, "totalSteps", 0) +
        this._.get(this.teamAggregateData, "totalActivities", 0);
      if (totalStepAndActivitiesSum) {
        return totalStepAndActivitiesSum.toLocaleString();
      } else {
        return "-";
      }
    }
  },

  async mounted() {
    this.teamAggregateData = await this.fetchTeamAggregate({
      teamId: this.team.id,
      todayDate: this.today().formatted
    });
    this.teamAggregateDataLoaded = true;
  },

  methods: {
    ...mapActions("teams", ["fetchTeamAggregate", "fetchTeamStepsData"])
  }
};
</script>

<style lang="sass" scoped>
.my-team
  position: relative
  min-height: 60px
  .view-details-link
    position: absolute
    top: 0
    right: 0
  .my-team-body
    padding: 1rem 0
    border-top: .5px solid $grey-light
</style>
